import SignInWithAppleButton from "../../components/SigninButton/SignInWithAppleButton.tsx";
import SignInWithGoogleButton from "../../components/SigninButton/SignInWithGoogleButton.tsx";
import './Signin.css';
import Footer from "../../Footer.tsx";

const SignIn = () => {
  return (
    <div className="mobile-wrapper">
      <div className="mobile-card">
        <div className="content-wrapper">
          <p className="pre-heading caption-md semibold">IT’S TIME</p>
          <h1>Ready to embark on this journey?</h1>
          <p className="post-heading body-lg">
            Start by creating an account to use Migiri.
          </p>
          <div className="sign-in-buttons">
            <SignInWithAppleButton />
            <SignInWithGoogleButton />
          </div>
        </div>
      </div>
      <Footer>
        <>
          By continuing you confirm that you’ve read and accepted our{" "}
          <a href="https://www.migiri.app/terms/" target="_blank">
            Terms
          </a>{" "}
          and{" "}
          <a href="https://www.migiri.app/privacy/" target="_blank">
            Privacy Policy
          </a>
          .
        </>
      </Footer>
    </div>
  );
};

export default SignIn;
